export function expenseToday(now = new Date()): string {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const part = (type: string) => parts.find((value) => value.type === type)?.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function expenseMonthRange(month: string, today: string): [string, string] {
  const [year, number] = month.split('-').map(Number);
  const last = new Date(Date.UTC(year, number, 0)).getUTCDate();
  return [`${month}-01`, [`${month}-${last}`, today].sort()[0]];
}

export function expenseNumber(amount: string | number | null | undefined): number | null {
  if (amount == null) return null;
  const value = Number(amount);
  return Number.isFinite(value) ? value : null;
}

export function canViewExpenses(role?: string | null): boolean {
  return role === 'owner' || role === 'admin';
}
